import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-new-current-pack-recharge",
  templateUrl: "./new-current-pack-recharge.component.html",
  styleUrls: ["./new-current-pack-recharge.component.scss"],
})
export class NewCurrentPackRechargeComponent implements OnInit, OnDestroy {
   emailQuota:any = []
  whatsappQuota:any = []
  applicableFunctionality: any[] = [];
  entityHashId: string = "";
  loader: boolean = false;
  _apiSubscription: Subscription;
  currentPlan: any[] = [];
  constructor(
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private loaderservice: LoaderServiceService,
    private navservice: NavigationService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    this.navservice.hideSidebarAndNav = false;
    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_ACTIVE_SUBSCRIPTION
      ) {
        this.currentPlan = [];
        if (resData.result) {
          if (resData.result[0].subscriptionActive == 1) {
            resData.result[0].status = "Active";
          } else if (resData.result[0].subscriptionActive == 0) {
            resData.result[0].status = "Not Active";
          }
          this.currentPlan.push(resData.result[0]);
        }
        this._apiService.getWhatsAppEmailQuotaAndUsage(this.entityHashId)
        if (
          sessionStorage.getItem("showToastAfterRechargeBusiness") &&
          sessionStorage.getItem("showToastAfterRechargeBusiness") == "1"
        ) {
          this.snackBar.open("Premium pack for this business recharged successfully.", "Ok", {
            duration: 3000,
            horizontalPosition: "center",
            verticalPosition: "bottom",
          });
          sessionStorage.removeItem('showToastAfterRechargeBusiness')
        }
      }
       if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_APP_FUNCTIONALITY_BY_ENTITY_ID
      ) {
        if (resData.result && resData.result != null) {
          this.applicableFunctionality = resData.result;
          this.applicableFunctionality.forEach((element) => {
            element.isValid = 0;

            if (element.type == 1) {
              element.isValid = 1;
            } else if (element.type == 2) {
              const date = new Date(element.accessibility_end_date);
              // const date = new Date('2023-11-01T00:00:00.000Z');

              const newdate = new Date();

              date.setHours(0, 0, 0, 0);
              newdate.setHours(0, 0, 0, 0);

              if (newdate <= date) {
                element.isValid = 1;
              } else {
                element.isValid = 0;
              }
            }
          });

    this._apiService.getEntityActiveSubscription(this.entityHashId);        
  }
      }
       if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_WHATSAPP_EMAIL_QUOTA_USAGE){
        this.emailQuota = []
        this.whatsappQuota = []
        if(resData.result){
          this.emailQuota = resData.result.filter((item:any) => item.quota_type == 'email')
          this.whatsappQuota = resData.result.filter((item:any) => item.quota_type == 'whatsapp')
        }
        this.loaderservice.showLoader = false
        this.loader = false
      }
    });
  }

  ngOnInit(): void {
     this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
    });
    this.loader = true;
    this.loaderservice.showLoader = true;
    this._apiService.getFunctionalityByEntityId(this.entityHashId);

  }

  renewBusiness() {
    this.router.navigate(["purchased-plans"], {
      queryParamsHandling: "preserve",
      relativeTo: this.route,
    });
  }
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }
}
